import "./index.css"

import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';

const Loader = forwardRef(({ size = 'l', weight = 'bold', className }, ref) => (jsx("div", { ref: ref, className: classNames('cds-loader', `cds-loader--size-${size}`, `cds-loader--weight-${weight}`, className) })));

export { Loader };
